<template>
  <section class="box">
    <!-- 🔹 SECCIÓN: Información del Producto -->
    <h2 class="section-title">Información del Producto</h2>
    <b-field grouped group-multiline>
      <b-field class="label-top" label="Código de Barras">
        <b-input
          type="text"
          icon="barcode"
          placeholder="Código de Barras"
          v-model="producto.codigo"
        ></b-input>
      </b-field>
      <b-field class="label-top" label="Nombre">
        <b-input
          placeholder="Nombre o descripción del producto"
          v-model="producto.nombre"
        ></b-input>
      </b-field>
    </b-field>

    <!-- 🔹 SECCIÓN: Precios -->
    <h2 class="section-title">Precios</h2>
    <b-field grouped group-multiline>
      <b-field class="label-top" label="Precio Compra">
        <b-input
          type="number"
          icon="currency-usd"
          step="any"
          placeholder="Precio de Compra"
          v-model="producto.precioCompra"
        ></b-input>
      </b-field>
      <b-field class="label-top" label="Precio Venta">
        <b-input
          type="number"
          icon="currency-usd"
          step="any"
          placeholder="Precio de Venta"
          v-model="producto.precioVenta"
          :min="producto.precioCompra"
          @input="actualizarPrecios"
        ></b-input>
      </b-field>
      <b-field class="label-top" label="Precio Venta 2">
        <b-input
          type="number"
          icon="currency-usd"
          step="any"
          placeholder="Precio de Venta 2"
          v-model="producto.precioVenta2"
        ></b-input>
      </b-field>
      <b-field class="label-top" label="Precio Venta 3">
        <b-input
          type="number"
          icon="currency-usd"
          step="any"
          placeholder="Precio de Venta 3"
          v-model="producto.precioVenta3"
        ></b-input>
      </b-field>
    </b-field>

    <!-- 🔹 SECCIÓN: Inventario -->
    <h2 class="section-title">Inventario</h2>
    <b-field grouped group-multiline>
      <b-field class="label-top" label="Existencia">
        <b-numberinput
          placeholder="Existencia"
          v-model="producto.existencia"
          :step="producto.existencia ? 'any' : 1"
          :disabled="esEditar === 'si'"
        ></b-numberinput>
      </b-field>

      <b-field class="label-top" label="Inventario Mínimo">
        <b-input
          type="number"
          icon="clipboard-minus"
          step="any"
          placeholder="Mínimo de Aviso"
          v-model="producto.inventarioMinimo"
        ></b-input>
      </b-field>
      <b-field class="label-top" label="Margen de Ganancia">
        <b-input
          icon="cash"
          placeholder="Margen Ganancia"
          :value="calcularMargenGanancia"
          readonly
          class="bold-text"
        ></b-input>
      </b-field>
    </b-field>

    <h2 class="section-title">Marcas y categorias</h2>
    <b-field label="Selecciona una marca">
        <b-select
          placeholder="Marca"
          icon="tag-multiple"
          v-model="producto.marca"
        >
          <option v-for="marca in marcas" :key="marca.id" :value="marca.id">
            {{ marca.nombreMarca }}
          </option>
        </b-select>
      </b-field>

      <b-field label="Selecciona una categoría">
        <b-select
          placeholder="Categoría"
          icon="archive"
          v-model="producto.categoria"
        >
          <option
            v-for="categoria in categorias"
            :key="categoria.id"
            :value="categoria.id"
          >
            {{ categoria.nombreCategoria }}
          </option>
        </b-select>
      </b-field>

    <!-- 🔹 SECCIÓN: Imagen del Producto -->
    <h2 class="section-title">Imagen del Producto</h2>
    <b-field>
      <label class="file-label">
        <input
          class="file-input"
          type="file"
          name="imagen"
          @input="onImageChange($event)"
          ref="imageInput"
        />
        <span class="file-cta">
          <span class="file-label">Seleccionar Imagen</span>
        </span>
      </label>
      <img
        v-if="producto.imagen"
        :src="
          producto.imagen.trim() !== ''
            ? producto.imagen
            : '../api/imgproductos/sinimagen.webp'
        "
        alt="Vista previa de la imagen"
        width="150"
        height="150"
        class="preview-image"
        @click="openImageModal(producto.imagen)"
      />
    </b-field>

    <!-- 🔹 SECCIÓN: Configuración Adicional -->
    <h2 class="section-title">Configuraciones Adicionales</h2>
    <b-field>
      <b-switch v-model="producto.vendidoMayoreo"
        >¿Vendido al Mayoreo?</b-switch
      >
      <b-switch v-model="producto.peso">¿Producto usa Peso?</b-switch>
    </b-field>

    <b-field grouped group-multiline v-if="producto.vendidoMayoreo">
      <b-field class="label-top" label="Precio Mayoreo">
        <b-input
          type="number"
          icon="currency-usd"
          step="any"
          placeholder="Precio de Venta al Mayoreo"
          v-model="producto.precioMayoreo"
        ></b-input>
      </b-field>
      <b-field class="label-top" label="Cantidad Mayoreo">
        <b-numberinput
          min="1"
          placeholder="Cantidad para Aplicar Mayoreo"
          v-model="producto.cantidadMayoreo"
        ></b-numberinput>
      </b-field>
    </b-field>

    <!-- 🔹 SECCIÓN: Promociones -->
    <h2 class="section-title">Promociones</h2>
    <b-field grouped group-multiline>
      <b-field class="label-top" label="Precio De Promo">
        <b-input
          type="number"
          icon="currency-usd"
          step="any"
          placeholder="Precio en Promoción"
          v-model="producto.precioPromo"
        ></b-input>
      </b-field>
      <b-field class="label-top" label="Periodo en Promo">
        <b-datepicker
          placeholder="Seleccionar Rango de Fechas"
          v-model="fechasSeleccionadas"
          range
          @input="onFechaSeleccionada"
        ></b-datepicker>
      </b-field>
    </b-field>

    <div v-if="fechamostrarinicio && fechamostrarfin">
      <p class="promo-fechas">
        <strong>Inicio Promo:</strong> {{ fechamostrarinicio }}
      </p>
      <p class="promo-fechas">
        <strong>Fin Promo:</strong> {{ fechamostrarfin }}
      </p>
    </div>

    <!-- 🔹 SECCIÓN: ERRORES -->
    <errores-component
      :errores="mensajesError"
      v-if="mensajesError.length > 0"
    />

    <!-- 🔹 SECCIÓN: Botones -->
    <div class="buttons-container">
      <b-button type="is-primary" icon-left="check" @click="registrar"
        >Registrar</b-button
      >
      <b-button
        type="is-dark"
        icon-left="cancel"
        tag="router-link"
        to="/inventario"
        >Cancelar</b-button
      >
    </div>
  </section>
</template>

<style scoped>
/* 🔥 Diseño premium con mejor distribución */

.section-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 10px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

.label-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.file-cta {
  background: #3498db;
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.3s ease;
}

.file-cta:hover {
  background: #2980b9;
}

.preview-image {
  display: block;
  margin-top: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.preview-image:hover {
  transform: scale(1.08);
}

.promo-fechas {
  font-size: 0.95rem;
  font-weight: bold;
  margin: 5px 0;
}

.buttons-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.buttons-container .b-button {
  width: 48%;
}
</style>

<script>
import Swal from "sweetalert2";
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";
import ErroresComponent from "../Extras/ErroresComponent";
export default {
  name: "FormProducto",
  props: ["productoProp", "productoProp2", "borrarFormulario"],
  components: { ErroresComponent },

  data: () => ({
    categorias: [],
    fechasSeleccionadas: [],
    fechamostrarinicio: "",
    fechamostrarfin: "",
    marcas: [],
    productos: [],
    producto: {
      codigo: "",
      nombre: "",
      precioCompra: "",
      precioVenta: "",
      precioVenta2: "",
      precioVenta3: "",
      existencia: 0,
      vendidoMayoreo: false,
      precioMayoreo: "",
      cantidadMayoreo: 0,
      categoria: "",
      marca: "",
      peso: false,
      precioPromo: 0,
      fechaInicio: "",
      fechaFin: "",
      inventarioMinimo: 0,
      imagen: "",
    },
    selectedImage: "",
    isModalVisible2: false,
    mensajesError: [],
    urlImagen: null,
    esEditar: "",
  }),
  async mounted() {
    this.ids = this.$route.params.id;
    const producx = await HttpService.obtenerConConsultas("productos.php", {
      accion: "obtener_por_id_kit",
      id: this.ids,
    });
    if (this.ids) {
      this.esEditar = "si";
    }
    this.productos = producx; // Cambiar a productos
    this.obtenerCategorias();
    this.obtenerMarcas();
    this.producto = this.productoProp;
    console.log(this.producto);
    this.producto.peso = this.productoProp.peso === 1 ? true : false;
    this.urlImagen = Utiles.regresarRuta() + this.productoProp.imagen;
    this.producto.vendidoMayoreo =
      this.productoProp.vendidoMayoreo === 1 ? true : false;
    this.producto.cantidadMayoreo = parseInt(this.productoProp.cantidadMayoreo);
    this.fechamostrarinicio = this.producto.inicioPromo;
    this.fechamostrarfin = this.producto.finPromo;
  },
  computed: {
    calcularMargenGanancia() {
      if (this.producto.precioCompra && this.producto.precioVenta) {
        const margen =
          ((this.producto.precioVenta - this.producto.precioCompra) /
            this.producto.precioCompra) *
          100;
        return isNaN(margen) ? "" : `${margen.toFixed(2)}%`;
      } else {
        return "";
      }
    },
  },

  watch: {
    borrarFormulario(newVal) {
      if (newVal) {
        this.resetearFormulario();
        console.log("aca llegue a borrarforumalrio");
      }
    },
  },

  methods: {
    openImageModal(imageUrl) {
      this.selectedImage = imageUrl; // Establecer la imagen seleccionada
      this.isModalVisible2 = true; // Mostrar el modal
    },

    async onImageChange(event) {
      let input = event.target; // Usamos el target del evento
      let file = input.files;

      if (file && file[0]) {
        // Verificar el tamaño de la imagen
        if (file[0].size > 10 * 1024 * 1024) {
          Swal.fire({
            icon: "info",
            title: "¡Error!",
            text: "La imagen no debe superar 10 MB de tamaño.",
          });
          input.value = ""; // Limpiar el input de archivo
          return;
        }

        // Mostrar vista previa
        let reader = new FileReader();
        reader.onload = (e) => {
          this.urlImagen = e.target.result; // Solo para vista previa
        };
        reader.readAsDataURL(file[0]);

        // Crear FormData para enviar al backend
        const formData = new FormData();
        formData.append("image", file[0]);

        try {
          // Subir la imagen al backend
          const response = await HttpService.subirArchivo(
            "subir_imagen.php",
            formData
          );

          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Imagen subida",
              text: "La imagen fue procesada y convertida con éxito.",
            });
            this.producto.imagen = response.path; // Guardar la ruta de la imagen
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "Hubo un problema al subir la imagen.",
            });
          }
        } catch (error) {
          console.error("Error al subir la imagen:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo conectar con el servidor.",
          });
        }
      }
    },

    actualizarPrecios() {
      // Actualiza precioVenta2 y precioVenta3 con el mismo valor que precioVenta
      //   this.producto.precioVenta2 = this.producto.precioVenta;
      //  this.producto.precioVenta3 = this.producto.precioVenta;
    },
    onFechaSeleccionada(fechasSeleccionadas) {
      this.producto.fechaInicio = fechasSeleccionadas[0]
        .toISOString()
        .split("T")[0];
      this.producto.fechaFin = fechasSeleccionadas[1]
        .toISOString()
        .split("T")[0];
      this.fechamostrarinicio = this.producto.fechaInicio;
      this.fechamostrarfin = this.producto.fechaFin;
    },
    registrar() {
      let producto = {
        Código: this.producto.codigo,
        Nombre: this.producto.nombre,
        "Precio compra": this.producto.precioCompra,
        "Precio venta": this.producto.precioVenta,
      };
      this.mensajesError = Utiles.validarDatos(producto);
      if (
        parseFloat(this.producto.precioVenta) <
        parseFloat(this.producto.precioCompra)
      ) {
        this.mensajesError.push(
          "El precio de venta debe ser mayor al precio compra"
        );
      }
      if (this.mensajesError.length > 0) return;
      this.$emit("registrado", this.producto, this.productos);
    },

    obtenerMarcas() {
      let payload = {
        accion: "obtener",
      };
      HttpService.obtenerConConsultas("marcas.php", payload).then((marcas) => {
        this.marcas = marcas;
      });
    },
    onSeleccionado(productox) {
      // producto.cantidadexistente = producto.existencia;
      // if (producto.existencia > 0) {
      //   producto.estado = "CONSTOCK";
      //   // Actualizar la existencia a 1 si es mayor que 1
      //   producto.existencia = 1;
      this.productos = [...this.productos, productox];
      //   console.log(producto);
      // } else {
      //   // Muestra un mensaje de error o realiza alguna acción indicando que la existencia es insuficiente.
      //   alert("La existencia de " + producto.nombre + " es inferior a 1.");
      //   producto.estado = "SINSTOCK";
      productox.existencia = 1;
      //   this.productos = [...this.productos, producto];
      //   console.log(producto);
    },

    obtenerCategorias() {
      let payload = {
        accion: "obtener",
      };
      HttpService.obtenerConConsultas("categorias.php", payload).then(
        (categorias) => {
          this.categorias = categorias;
        }
      );
    },
    eliminarProducto(index) {
      this.productos.splice(index, 1);
    },
  },
};
</script>

<style>
.bold-text {
  font-weight: bold;
}
</style>
